import configs from "./configs";

const { VITE_CONFIG } = import.meta.env;
const config = configs[VITE_CONFIG] || configs.sbm;

// Set the correct title
document.title = config.title;
export default config;
